module.exports = __webpack_public_path__ + "img/Weapon_22.b4a3a417.png";